import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveRoadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove_road"}/>
}
